import './btn.scss';
import Sloth from '../Sloth';


/** WEBPACK FOOTER **
 ** ./components/Btn/btn.js
 **/